/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `Wir können Ihren Standort nicht genau ermitteln.`
};

const en_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `We can't find your exact location.`
};

const es_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `No hemos podido determinar tu ubicación exacta.`
};

const fr_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `Nous n'arrivons pas à déterminer votre position exacte.`
};

const it_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `Non riusciamo a determinare la tua posizione esatta.`
};

const nl_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `We kunnen uw exacte locatie niet bepalen.`
};

const pt_location_control__error = /** @type {(inputs: {}) => string} */ () => {
	return `Não conseguimos determinar a sua posição exata.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.location_control__error(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("location_control__error", locale)
	if (locale === "de") return de_location_control__error(inputs)
	if (locale === "en") return en_location_control__error(inputs)
	if (locale === "es") return es_location_control__error(inputs)
	if (locale === "fr") return fr_location_control__error(inputs)
	if (locale === "it") return it_location_control__error(inputs)
	if (locale === "nl") return nl_location_control__error(inputs)
	return pt_location_control__error(inputs)
};